import { gql } from '@apollo/client';

export const gameFragment = gql`
  fragment Game on Game {
    id
    scene {
      id
      name
      background
      hackerBackground
      employeeBackground
      code
    }
    gameDifficulty
    status
    turn
    winner
    percentageOfEliminatedAttacks
    myRole
    round
    isPreview
    isTutorial
    previewType
    field {
      zones {
        id
        color
        defenseCards {
          id
          text
          image
          isHidden
          points
          additionalText
          link
          linkText
        }
        threatCards {
          id
          text
          image
          isHidden
          points
          additionalText
          link
          linkText
        }
        hackerPoints
        employeePoints
        isSecretTarget
      }
      hasSecretTarget
      threatDeckSize
      defenseDeckSize
    }
    hacker {
      name
      hand {
        id
        text
        image
        points
        additionalText
        link
        linkText
      }
      type
      user {
        id
        company {
          id
          guide {
            id
            pointingRight
            pointingLeft
            pointingThumbTopRight
            pointingUp
          }
        }
      }
    }
    employee {
      name
      hand {
        id
        text
        image
        points
        additionalText
        link
        linkText
      }
      type
      user {
        id
        company {
          id
        }
      }
    }
    myDecisions {
      good
      bad
    }
    actualEvent
  }
`;

const lobbyGamePlayer = gql`
  fragment LobbyGamePlayer on Player {
    name
    user {
      id
      onlineStatus
      gameDifficulty
    }
  }
`;

export const lobbyGameFragment = gql`
  fragment LobbyGame on Game {
    id
    status
    scene {
      id
      name
    }
    createdAt
    turn
    myRole
    gameDifficulty
    hacker {
      ...LobbyGamePlayer
    }
    employee {
      ...LobbyGamePlayer
    }
  }
  ${lobbyGamePlayer}
`;

export const trainingCompletionRequirementsFragment = gql`
  fragment TrainingCompletionRequirements on Company {
    id
    trainingCompletionRequirements {
      finishAgainstPlayer
      winAgainstCPU
      allowTutorial
      finishedGamesInScene
      percentageOfEliminatedAttacks
    }
  }
`;

export const userFragment = gql`
  fragment BasicUserInfo on User {
    id
    name
    email
    language
    notificationSound
    company {
      logo
      id
      securityManagerName
      defaultLanguage {
        code
      }
      ...TrainingCompletionRequirements
      gamesConfig {
        code
        active
      }
      guide {
        id
        pointingRight
        pointingLeft
        pointingThumbTopRight
        pointingUp
      }
      # We don't need it in this fragment, bud it is missing in Game because of caching policy
      # see issue & comment https://github.com/apollographql/apollo-client/issues/6136#issuecomment-635282012
      gameFinishedConfig { 
        lmsName
        redirectToUrl
      }
    }
    hasUnconfirmedNotification
    canAccessGame
    skipTutorial
    skipPreview
    gameDifficulty
  }
  ${trainingCompletionRequirementsFragment}
`;
